import { __assign } from "tslib";
import { CURRENCY_HEADER_NAME, MULTI_LANG_HEADER_NAME } from '@wix/wixstores-client-core';
import { getApiBaseUrl } from '../utils/getWixApiBaseUrl';
import { DEFAULT_CURRENCY_HEADER, SPECS } from '../constants';
import { getCurrencyHeader as getCurrencyHeaderValue } from '../utils/headers';
export function getSDKAuthAndHost(siteStore) {
    return {
        auth: {
            getAuthHeaders: function () {
                var _a, _b;
                var currencyHeader = getCurrencyHeader(siteStore);
                var multiLangHeader = siteStore.getMultiLangHeader();
                return {
                    headers: __assign(__assign({ Authorization: siteStore.instanceManager.getInstance() }, (currencyHeader ? (_a = {}, _a[CURRENCY_HEADER_NAME] = currencyHeader, _a) : {})), (multiLangHeader ? (_b = {}, _b[MULTI_LANG_HEADER_NAME] = multiLangHeader, _b) : {})),
                };
            },
        },
        host: {
            apiBaseUrl: getApiBaseUrl(siteStore.isSSR(), siteStore.location.baseUrl),
        },
    };
}
function getCurrencyHeader(siteStore) {
    return siteStore.experiments.enabled(SPECS.AlwaysSendCurrencyHeader)
        ? getCurrencyHeaderValue(siteStore.wixCodeApi) || DEFAULT_CURRENCY_HEADER
        : siteStore.getCurrencyHeader();
}
//# sourceMappingURL=getSDKAuthAndHost.js.map